import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, AlertActions, AlertMutations } from './types';
import AlertService from '@/shared/services/AlertService';
import state from '../state';
const _alertActions = namespaceHelper.removeNamespace(namespace, AlertActions);
const _alertMutations = namespaceHelper.removeNamespace(namespace, AlertMutations);

export default {
  async [_alertActions.FETCH_ALERTS]({ commit }) {
    var url = state.url;
    var isFire = url.includes('localhost:8050') || url.includes('clarkefire.com');
    if (!isFire) {
      const result = await AlertService.getAlerts();
      commit(_alertMutations.SET_ALERTS, result.data);
    }
  },
  [_alertActions.UPDATE_EMPLOYEE_ALERTS](state, params) {
    AlertService.updateEmployeeAlerts(params);
  }
};
